import locale from "localization";

export const paymentMethod = [
  { label: locale.cash, value: "cash" },
  { label: locale.creditCard, value: "card" },
  { label: locale.check, value: "check" },
];
